import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface DeleteProformaType {
  oidLiquidacion: number;
}

export const deletedImportFCL = async (
  query: DeleteProformaType
): Promise<[]> => {
  try {
    const res = await apiClient.post<ApiResponse<[]>>(Endpoints.deleted, query);
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
